module.exports = __webpack_public_path__ + "img/icon_cancelB.3e1e14f6.svg";